import axios from "../utils/APIUtils";
// import { PROFILES_API_PATHS } from "src/constants/urlPathAndQueryParams";
import { PROFILES_API_PATHS } from "../constants/urlPathAndQueryParams";

export const getActiveLoggedUsers = async (current_role: string, duration: number) => {
  return await axios
    .get<any>(PROFILES_API_PATHS.activeUsers, {params: {current_role, duration}})
    .then((response) => {
     return response.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const activityBeam = async () => {
  return await axios
    .get<any>(PROFILES_API_PATHS.activeUser)
    .then((response) => {
     return response.data;
    })
    .catch((err) => {
      throw err;
    });
}

export const getLvl3Roles = async () => {
  return await axios
    .get(`${PROFILES_API_PATHS.acpRoles}`)
    .then((response) => {
      return response.data
        .map((role: any) => role["assigned_target_lvl3"])
        .filter((role: any) => role !== null)
        .join(","); //remove null values from lvl3 and join lvl3 together
    })
    .catch((err) => {
      console.log("Lvl3 API error", err);
      throw err;
    });
};


export const getuiMessages = async () => {
  try {
      const response = await axios.get<any>(PROFILES_API_PATHS.uimessages);
      // console.log(JSON.stringify(response.data));
      return response.data;
  } catch (err) {
      console.log("getUIMessages error", err);
      throw err;
  }
};
